import React from "react";

import { Table } from "antd";
import { FiChevronRight } from "react-icons/fi";
import Button from "shared/components/Button";

import "./styles.scss";

const dataSource = [
  {
    key: "1",
    date: "15.02.2020",
    dossier: "0016657",
    designation: "Lave vaisselle LV AKR2469N vaisselle LV AKR2469N Whirlpool",
    qty: "1",
    montant: "45,30 €",
  },
  {
    key: "2",
    date: "15.02.2020",
    dossier: "0016657",
    designation: "Lave vaisselle LV AKR2469N Whirlpool",
    qty: "1",
    montant: "45,30 €",
  },
];

const columns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Dossier",
    dataIndex: "dossier",
    key: "dossier",
  },
  {
    title: "Désignation",
    dataIndex: "designation",
    key: "designation",
  },
  {
    title: "Quantité",
    dataIndex: "qty",
    key: "qty",
  },
  {
    title: "Montant",
    dataIndex: "montant",
    key: "montant",
  },
];

const ListOnMobile = ({ items }) => {
  return items.map((data, index) => {
    return (
      <div
        key={index}
        className="regulations--wrapper--mobile--content--list--item">
        <div className="regulations--wrapper--mobile--content--list--item--head">
          <span>
            {data.date} • Dossier {data.dossier}
          </span>
          <FiChevronRight size={24} />
        </div>
        <div className="regulations--wrapper--mobile--content--list--item--title">
          <h3>{data.designation}</h3>
        </div>
        <div className="regulations--wrapper--mobile--content--list--item--qt">
          <h3>{data.qty}</h3>
          <h3>{data.montant}</h3>
        </div>
      </div>
    );
  });
};

const Component = () => {
  return (
    <>
      <div className={"regulations--wrapper"}>
        <div className={"regulations--wrapper--content"}>
          <div className={"regulations--wrapper--content--heading"}>
            <h2
              className={
                "regulations--wrapper--content--heading--title heading--24"
              }>
              Règlements en attente
            </h2>
            <div className={"regulations--wrapper--content--heading--right"}>
              <Button text={"Régler la totalité"} />
            </div>
          </div>
          <div className={"regulations--wrapper--content--table p-top-40"}>
            <Table
              className="custom--table"
              dataSource={dataSource}
              columns={columns}
              pagination={false}
            />
          </div>
          <div className={"regulations--wrapper--content--total"}>
            <div className={"regulations--wrapper--content--total--item"}>
              <div
                className={"regulations--wrapper--content--total--item--value"}>
                <h3>Total (HT)</h3>
                <h3>172,80 €</h3>
              </div>
              <div
                className={"regulations--wrapper--content--total--item--value"}>
                <h3>Total (TTC)</h3>
                <h3>207,36 €</h3>
              </div>
            </div>

            <div className={"regulations--wrapper--content--total--item"}>
              <div
                className={"regulations--wrapper--content--total--item--value"}>
                <h3>Reste à régler</h3>
                <h3>207,36 €</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile */}
      <div className={"regulations--wrapper--mobile"}>
        <div className={"regulations--wrapper--mobile--content"}>
          <div className={"regulations--wrapper--mobile--content--heading"}>
            <h2
              className={
                "regulations--wrapper--mobile--content--heading--title heading--24"
              }>
              Règlements en attente
            </h2>
          </div>

          <div
            className={"regulations--wrapper--mobile--content--list p-top-20"}>
            <ListOnMobile items={dataSource} />
          </div>

          <div className={"regulations--wrapper--mobile--content--total"}>
            <div
              className={"regulations--wrapper--mobile--content--total--item"}>
              <div
                className={
                  "regulations--wrapper--mobile--content--total--item--value"
                }>
                <h3>Total (HT)</h3>
                <h3>172,80 €</h3>
              </div>
              <div
                className={
                  "regulations--wrapper--mobile--content--total--item--value"
                }>
                <h3>Total (TTC)</h3>
                <h3>207,36 €</h3>
              </div>
            </div>
            <div
              className={"regulations--wrapper--mobile--content--total--item"}>
              <div
                className={
                  "regulations--wrapper--mobile--content--total--item--value"
                }>
                <h3>Reste à régler</h3>
                <h3>207,36 €</h3>
              </div>
            </div>
          </div>
          <div className={"regulations--wrapper--mobile--content--footer"}>
            <Button
              custom={"regulations--wrapper--mobile--content--footer--btn"}
              text={"Régler la totalité"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

Component.propTypes = {};

export default Component;
